import { createUserManager } from 'redux-oidc';
import * as Constants from '../constants/Constants';

const params = new URLSearchParams(window.location.search);
const isLocalhost = window.location.hostname === 'localhost';

const getConfig = () => {
    return {
        client_id: Constants.TC_KEY_ID,
        redirect_uri: isLocalhost ? 'http://localhost:8080/ui/signin' : Constants.REDIRECT_URI,
        scope: Constants.SCOPE_NAME,
        authority: Constants.AUTHORITY_NAME,
        post_logout_redirect_uri: isLocalhost
            ? 'http://localhost:8080/'
            : Constants.LOGOUT_REDIRECT_URI,
        extraQueryParams: params.has(Constants.AUTH_WORKFLOW)
            ? { auth_workflow: params.get(Constants.AUTH_WORKFLOW) }
            : null,
        loadUserInfo: false,
        response_type: 'code',
        revokeAccessTokenOnSignout: true,
        automaticSilentRenew: true
    };
};

export default createUserManager(getConfig());
